import React, { useState, useEffect } from "react";
import {
  Card,
  Input,
  Button,
  Avatar,
  Typography,
  List,
  Select,
  Row,
  Col,
  Modal,
  Timeline,
  Spin,
} from "antd";
import {
  SearchOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { motion } from "framer-motion";
import icon from "../assets/images/delivery (1).png";
import colors from "../../assets/styles/colour";

import dataService from "../../networks/api/service/dataService";
import { useNavigate } from "react-router-dom";
import { AiOutlinePlusCircle } from "react-icons/ai";

const { Title, Text } = Typography;
const { Option } = Select;

const TripManagement = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [tripList, setTripList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTrips = async () => {
      setLoading(true);
      try {
        const response = await dataService.getTrip();
        if (response?.data) {
          setTripList(response.data);
        }
      } catch (error) {
        console.error("Error fetching trips:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrips();
  }, []);

  const filteredTrips = tripList.filter((trip) =>
    trip.vehicle?.makeAndModel?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
     <motion.div
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5 }}
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap", // Important for responsiveness
    gap: "10px", // Space between items when wrapped
    marginBottom: 20,
  }}
>
  {/* Center: Icon + Title */}
  <div style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    minWidth: "250px", // Allow wrapping when screen is small
  }}>
    <motion.img
      src={icon}
      alt="Trip Icon"
      style={{
        width: "40px",
        height: "40px",
        marginRight: "10px",
        animation: "bounce 4s infinite",
      }}
    />
    <Title
      level={3}
      style={{ margin: 0, textAlign: "center" }}
    >
      Trip Management
    </Title>
  </div>

  {/* Right: Button */}
  <div style={{ minWidth: "150px", textAlign: "right" }}>
    <Button
      icon={<AiOutlinePlusCircle />}
      onClick={() => navigate("/login/add-trip")}
      style={{
        backgroundColor: "rgba(128, 128, 128, 0.3)",
        borderColor: "rgba(128, 128, 128, 0.5)",
        color: "#333",
        backdropFilter: "blur(4px)",
        padding: "6px 16px",
        borderRadius: "8px",
        fontWeight: "500",
        transition: "all 0.3s ease",
        width: "100%", // Button will shrink on smaller screens
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.5)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.7)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "rgba(128, 128, 128, 0.3)";
        e.currentTarget.style.borderColor = "rgba(128, 128, 128, 0.5)";
      }}
    >
      Add Trip
    </Button>
  </div>
</motion.div>



      <Row gutter={[16, 16]} style={{ marginBottom: 30 }}>
        <Col xs={24} sm={8}>
          <Input
            placeholder="Search Trip by Vehicle..."
            prefix={<SearchOutlined style={{ color: colors.buttoSecondary }} />}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
        {/* <Col xs={24} sm={8}>
          <Select
            style={{ width: "100%" }}
            value={statusFilter}
            onChange={(value) => setStatusFilter(value)}
          >
            <Option value="All">All</Option>
            <Option value="Available">Available</Option>
            <Option value="Unavailable">Unavailable</Option>
          </Select>
        </Col> */}
      </Row>

      {loading ? (
        <div style={{ textAlign: "center", marginTop: 50 }}>
          <Spin size="large" />
        </div>
      ) : (
        <Row gutter={[16, 16]} align="middle">
          {filteredTrips.map((trip) => (
            <Col span={24} key={trip.id}>
              <motion.div
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.3 }}
              >
                <Card
                  style={{
                    borderRadius: 15,
                    background: "linear-gradient(135deg, #f0f4ff, #dfe9f3)",
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.15)",
                    cursor: "pointer",
                    border: "none",
                    overflow: "hidden",
                  }}
                  onClick={() => setSelectedTrip(trip)}
                >
                  <Row gutter={[20, 20]} align="middle">
                    <Col xs={24} sm={6} style={{ textAlign: "center" }}>
                      <Avatar
                        src={trip.image  || "https://static.vecteezy.com/system/resources/previews/026/615/556/non_2x/driver-icon-isolated-on-white-background-vector.jpg"}
                        size={90}
                        shape="square"
                        style={{ borderRadius: "10px" }}
                      />
                    </Col>
                    <Col span={12} sm={12} xs={24}>
                      <Title level={4} style={{ color: "#2c3e50" }}>
                        {trip.vehicle?.makeAndModel || "No Vehicle Info"}
                      </Title>
                      <Text style={{ fontSize: "14px", color: "#34495e" }}>
                        Driver: {trip.driver?.driverName || "N/A"}
                      </Text>
                      <br />
                      <Text style={{ fontSize: "14px", color: "#34495e" }}>
                        Start Date:{" "}
                        {new Date(trip.startDateTime).toLocaleString()}
                      </Text>
                      <br/>
                      <Text style={{ fontSize: "14px", color: "#34495e" }}>
                        End Date: {new Date(trip.endDateTime).toLocaleString()}
                      </Text>
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <Button
                        icon={<InfoCircleOutlined />}
                        style={{ backgroundColor: colors.buttoSecondary }}
                        type="primary"
                        onClick={() => navigate("/login/trip-details", { state: { trip } })}
                      >
                        View Details
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      )}

   
    </div>
  );
};

export default TripManagement;
